import "./assets/main.css";
import "./assets/main.scss";

import { createApp } from "vue";
import { createPinia } from "pinia";
import vuetify from "./plugins/vuetify";
import App from "@/App.vue";
import router from "./router";
import VueApexCharts from "vue3-apexcharts";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(vuetify);
// eslint-disable-next-line vue/multi-word-component-names
app.component("apexchart", VueApexCharts);

app.mount("#thor-ai");
